.cardContainer {
    background-color: #E6F2FA;
}

.workTitle {
    text-align: center;
    font-family: var(--font-serif);
    text-transform: uppercase;
    font-size: 14px;
    letter-spacing: 1.5px;
    color: #937b70;
    font-weight: 600;
    margin-bottom: 25px;
    margin-top: 0;
    padding-top: 25px;
}

.workText {
    text-align: center;
    margin-bottom: 70px;
    color: #4a4a4a;
}

.workCard {
    justify-content: center;
    display: flex;
}

.cardTitle {
    max-width: 370px;
    font-size: 2em;
    margin: 0;
    font-weight: 700;
}

.line {
    margin-top: 25px;
    margin-bottom: 25px;
    height: 4px;
    width: 25%;
    background-color: #1C1D25;
}

.workDescription {
    margin: 0;
    max-width: 500px;
    font-size: 1.3em;
    word-spacing: 4px;
    text-align: justify-all;
    line-height: 27px;
    font-family: var(--font-serif);
}

.workDescription strong {
    color: #00c8e7;
}

.phoneContainer {
    margin-left: 150px;
    display: flex;
    align-items: center;
}

.phoneContainerMob {
    display: none;
}

.phoneCard {
    width: 250px;
    height: 500px;
}

.paletteTitle {
    text-align: center;
    font-family: var(--font-serif);
    text-transform: uppercase;
    font-size: 14px;
    letter-spacing: 1.5px;
    color: #937b70;
    font-weight: 600;
    margin: 60px 0 0;
}

.circleContainer {
    margin-top: 30px;
    display: flex;
    justify-content: center;
    padding-bottom: 30px;
}

@media (max-width: 1200px) {
    .workCard {
        padding: 0 24px;
    }

    .phoneContainer {
        margin-left: 40px;
    }
}

@media (max-width: 1000px) {
    .workText {
        margin-bottom: 40px;
    }

    /* the phone is hidden here, the title and the text take the whole width */
    .workCard > div:first-child {
        width: 100%;
        max-width: 640px;
    }

    .cardTitle, .workDescription {
        max-width: none;
    }

    /* two classes, to win over the text styles of a case screen */
    .workCard .workDescription > * {
        max-width: none;
        min-width: 0;
        text-align: justify;
        hyphens: auto;
        word-spacing: normal;
    }
}